import script from "./StorefrontLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./StorefrontLoader.vue?vue&type=script&setup=true&lang=js"

import "./StorefrontLoader.vue?vue&type=style&index=0&id=ec810e02&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.35_typescript@5.9.3__webpack@5.107.2_4de69cea878ee2f242d39cab111b5a83/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec810e02"]])

export default __exports__